export function getActiveRoundsCategoryKey(categories: readonly { categoryKey: string }[], activeKey: string) {
  return categories.some(category => category.categoryKey === activeKey)
    ? activeKey : categories[0]?.categoryKey || "";
}

export function canGenerateMissingPocoCategory({ isPoco, usesCategories, categoryKey, hasRounds, finished }: {
  isPoco: boolean; usesCategories: boolean; categoryKey: string; hasRounds: boolean; finished: boolean;
}) {
  return isPoco && usesCategories && Boolean(categoryKey) && !hasRounds && !finished;
}

export function groupCategoryRounds<T extends { categoryKey?: unknown }>(
  rounds: T[][], categories: readonly { categoryKey: string }[],
) {
  const grouped = new Map<string, { round: T[]; sourceIndex: number }[]>();
  categories.forEach(category => grouped.set(category.categoryKey, []));
  rounds.forEach((round, sourceIndex) => {
    const key = String(round.find(match => String(match?.categoryKey || "").trim())?.categoryKey || "").trim();
    const resolvedKey = key || (categories.length === 1 ? categories[0].categoryKey : "");
    grouped.get(resolvedKey)?.push({ round, sourceIndex });
  });
  return grouped;
}
